#import "../../../../core/select/fragments/activity-type-fragment.graphql"

mutation DeleteActivityType($input: ActivityTypeDeleteInput!) {
    activityTypeDelete(input: $input) {
        activityType {
            ...ActivityType
        }
    }
}
